import { cleanURL, post } from '../utils/functions';

class PressRoom {
	callbacks = {
		open: [],
		close: [],
		search: [],
		update: [],
	};

	constructor(section, args = {}) {
		const sectionID = 'id-' + Math.random().toString(36).substr(2, 7);
		this.section = section;
		this.section.id = sectionID;
		this.header = document.querySelector('header');
		this.baseURL = window.location.href;

		this.args = {
			post_type: this.section.dataset.postType,
			slug: this.section.dataset.slug,
			term: this.section.dataset.term,
			containerSelector: '.posts-wrapper',
			postsContainerSelector: '.press__posts',
			scrollAnchorSelector: '.press__posts',
			postLinkSelector: '.tease',

			...args,
		};

		this.container =
			section.querySelector(this.args.containerSelector) || document.querySelector(this.args.containerSelector);
		this.scrollAnchor =
			section.querySelector(this.args.scrollAnchorSelector) || document.querySelector(this.args.scrollAnchorSelector);
		this.postsContainer =
			section.querySelector(this.args.postsContainerSelector) ||
			document.querySelector(this.args.postsContainerSelector);
		this.contents = {};

		// Init search form
		this.searchForm = this.section.querySelector('.search__form');
		if (this.searchForm) {
			this.searchInput = this.section.querySelector('.search__input');
			this.searchForm.addEventListener('submit', this.onSearch);
		}

		// Set posts
		const posts = section.querySelectorAll(this.args.postLinkSelector);
		this.updatePosts(posts);

		cleanURL();
	}

	handlePopState = (ev) => {
		if (this.isModalActive()) {
			ev.preventDefault();
			ev.stopPropagation();
			this.close();
		}
	};

	onSearch = (ev) => {
		ev.preventDefault();
		const search = this.searchInput.value;

		return post(
			{
				action: 'get_posts',
				search,
				post_type: this.args.post_type,
				term: this.args.term,
			},
			(response) => {
				const parsedResponse = JSON.parse(response);
				this.postsContainer.innerHTML = parsedResponse.data;
				const posts = this.postsContainer.querySelectorAll(this.args.postLinkSelector);
				this.updatePosts(posts);
				this.trigger('search', this);
			}
		);
	};

	trigger(event, params = []) {
		if (!this.callbacks.hasOwnProperty(event) || !Array.isArray(this.callbacks[event]))
			throw new Error(`Archive: "${event}" event does not exist`);

		this.callbacks[event].forEach((callback) => callback(...params));
	}

	updatePosts = (posts = []) => {
		posts.forEach((el) => {
			const id = el.dataset.id;
			const slug = el.dataset.slug;

			const post = {
				el,
				id,
				slug,
				status: null,
			};
		});
	};

	loading = (isLoading = true) =>
		isLoading ? this.section.classList.add('loading') : this.section.classList.remove('loading');
}

export default PressRoom;
